// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from theme.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function ThemeIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8 12a1 1 0 0 1 .993.883L9 13v2a1 1 0 0 1-1.993.117L7 15v-2a1 1 0 0 1 1-1Zm-2.828-1.172a1 1 0 0 1 .077 1.327l-.077.088-1.415 1.414a1 1 0 0 1-1.492-1.327l.078-.087 1.414-1.415a1 1 0 0 1 1.415 0Zm6.983-.077.088.077 1.414 1.415a1 1 0 0 1-1.327 1.492l-.087-.078-1.415-1.414a1 1 0 0 1 1.327-1.492ZM8 5c1.552 0 3 1.448 3 3s-1.448 3-3 3-3-1.448-3-3 1.448-3 3-3Zm7 2a1 1 0 0 1 .117 1.993L15 9h-2a1 1 0 0 1-.117-1.993L13 7h2ZM3 7a1 1 0 0 1 .117 1.993L3 9H1a1 1 0 0 1-.117-1.993L1 7h2Zm10.657-4.657a1 1 0 0 1 .078 1.327l-.078.087-1.414 1.415a1 1 0 0 1-1.492-1.327l.077-.088 1.415-1.414a1 1 0 0 1 1.414 0ZM3.67 2.265l.087.078 1.415 1.414A1 1 0 0 1 3.845 5.25l-.088-.077-1.414-1.415A1 1 0 0 1 3.67 2.265ZM8 0a1 1 0 0 1 .993.883L9 1v2a1 1 0 0 1-1.993.117L7 3V1a1 1 0 0 1 1-1Z"
      />
    </svg>
  );
}
